// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 143 ? "716b6f04" : chunkId) + "." + {"143":"c02bb107437a129e","556":"d178432d7b436d09"}[chunkId] + ".js";
};